export const margins = {
    margin00: '10px',
    margin01: '20px',
    margin02: '30px',
    margin03: '40px',
    margin04: '50px',
    margin05: '100px'
};
